var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageType === 'OEGG')?_c('register-form'):(_vm.currentPageType === 'register-rockbowl')?_c('rockbowl-form'):(_vm.pageType != null)?_c('registration-form',{attrs:{"pageType":_vm.pageType}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }